import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-k8s-node",
  "use": "oc-res-k8s-node-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-res-k8s-node\"><defs><style type=\"text/css\"></style></defs><path d=\"M513.152 41.6l-403.2 230.4v480l403.2 243.2 403.2-243.2v-480z\" p-id=\"11605\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol